// Balloon-specific positioning and SVG paths

// Face positioning coordinates within the balloon
export const FACE_BOX = {
  leftEye: { x: 80, y: 80 },
  rightEye: { x: 120, y: 80 },
  mouth: { x: 80, y: 120 },
} as const;

// SVG mask paths for balloon shapes
export const HEAD_MASK = {
  balloon:
    'M105.707 178.871C100.002 177.368 94.6217 174.967 89.5655 171.667C80.5862 165.609 73.4144 157.431 68.0501 147.133C62.8025 136.835 60.1203 125.204 60.0037 112.241C59.8871 100.004 62.5109 88.7972 67.8752 78.6203C73.2395 68.4433 80.4696 60.326 89.5655 54.2683C98.6614 48.0894 108.807 45 120.002 45C131.197 45 141.284 48.0894 150.263 54.2683C159.359 60.326 166.589 68.4433 171.954 78.6203C177.318 88.7972 180 100.004 180 112.241C180 125.204 177.318 136.895 171.954 147.315C166.706 157.734 159.534 165.972 150.438 172.03C145.326 175.366 139.883 177.746 134.108 179.169C128.718 180.497 125.467 181.054 119.908 180.996C114.348 180.938 111.083 180.288 105.707 178.871Z',
  stem: 'M110.749 179H129.25L131.832 189.458C132.168 190.794 132 192.062 131.327 193.264C130.654 194.421 129.518 195 127.919 195H112.081C110.482 195 109.346 194.421 108.673 193.264C108 192.062 107.832 190.794 108.168 189.458L110.749 179Z',
} as const;
